import { Link } from 'react-router-dom';

import { LogoMark } from '../common/LogoMark';
import { cn } from '../../utils/cn';

/**
 * Brand mark + wordmark — .pen aside-brand / pane-brand (horizontal, 28px mark).
 */
export function AuthBrand({ className, markClassName, tone = 'default', to }) {
  const wordmarkClass = tone === 'onSage' ? 'text-white' : 'text-foreground';
  const markTone = tone === 'onSage' ? 'text-white' : 'text-sage-500';

  const content = (
    <>
      <span
        className={cn(
          'flex size-7 shrink-0 items-center justify-center rounded-ds-full',
          tone === 'onSage' ? 'bg-white/15' : 'bg-sage-tint',
        )}
      >
        <LogoMark className={cn('size-4', markTone, markClassName)} />
      </span>
      <span className={cn('font-display text-[17px] font-bold tracking-tight', wordmarkClass)}>
        EvPlanner
      </span>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={cn('inline-flex items-center gap-space-2 no-underline', className)}>
        {content}
      </Link>
    );
  }

  return <div className={cn('inline-flex items-center gap-space-2', className)}>{content}</div>;
}
